import client, { mock, isRealApiEnabled } from "./client";
import categoriesMock from "./mocks/categories";

/**
 * @endpoint GET /api/v1/categories
 * WWG Store App Categories tree. Nodes: { code, title, level, children: [] }.
 * @returns {Promise<Array<{code:string,title:string,level:number,children:Array}>>}
 */
export function list() {
  if (isRealApiEnabled()) return client.get("/v1/categories");
  return mock(categoriesMock);
}
